import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/es/prestamos-dscr")({
  component: DscrLayout,
});

function DscrLayout() {
  return <Outlet />;
}
